<template>
  <v-row class="d-flex px-0 pl-3" justify="space-between">
    <v-col cols="12" sm="12" md="6" lg="6" class="mx-auto">
      <v-card min-height="500">
        <v-card-title class="text-body-1 font-weight-bold"> Historias Clínicas </v-card-title>
        <v-card-subtitle class="text-body-2">
          Estos son lo registros de tus historias Clínicas creadas. La información específica de
          cada una es administrada solo por el profesional de la salud mental.
        </v-card-subtitle>
        <v-card-text>
          <span class="text-caption">
            Puedes activar los check de las secciones de cada historia clínica que deseas
            transferir.
          </span>
          <v-treeview
            v-model="inputProxy"
            :items="items"
            item-key="id"
            item-text="name"
            item-children="children"
            :selection-type="selectionType"
            return-object
            selectable
            open-on-click
            shaped
            hoverable
            dense
            small
          >
            <template v-slot:label="{ item }">
              <span style="font-size: 13px">{{ item.name }}</span>
            </template>
          </v-treeview>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions class="mx-auto justify-end align-end mr-7">
          <v-row class="mt-3 mb-1">
            <v-dialog-transfer
              :dialogItem="dialogItem"
              :recordProfes="recordProfes"
              :saveTransfer="saveTransfer"
              :updateInputProfes="updateInputProfes"
              :codeTransfer="codeTransfer"
            />
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="6">
      <v-card min-height="500">
        <v-card-title class="text-body-1 font-weight-bold"> Transferidas </v-card-title>
        <v-card-subtitle class="text-body-2">
          Estos son los registros de las transferencias realizadas.
        </v-card-subtitle>
        <v-card-text>
          <v-row v-for="(item, index) in recordTransfers" :key="index">
            <v-col cols="12" class="font-weight-bold ml-2">
              {{ item.dateTransfer }}
            </v-col>
            <v-row class="mx-4">
              <v-expansion-panels multiple>
                <v-expansion-panel v-for="(itemHCP, index) in item.regHCP" :key="index">
                  <v-expansion-panel-header class="text-body-2 py-0">
                    {{ itemHCP.hcp }}
                    <span>---[{{ itemHCP.profesSends }}]</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row
                      v-for="(itemHCPd, index) in itemHCP.details"
                      :key="index"
                      class="text-caption ml-3"
                    >
                      {{ itemHCPd }}
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-col class="d-flex justify-end pt-0 mt-0">
                <v-icon>mdi-transfer-right</v-icon>
                {{ item.profesReceives }}
              </v-col>
            </v-row>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import VDialogTransfer from '@/components/base/VDialogTransfer.vue';

export default {
  name: 'VMenuPat',
  components: {
    VDialogTransfer,
  },
  props: {
    input: {
      type: Array,
      default: () => []
    },
    dialogItem: Array,
    recordHCP: Array,
    recordProfes: Array,
    recordTransfers: Array,
    saveTransfer: Function,
    updateInput: Function,
    updateInputProfes: Function,
    codeTransfer: String,
  },

  data: () => ({
    avatar: null,
    selectionType: 'leaf',
  }),

  computed: {
    items() {
      const sortedHCP = [...this.recordHCP].sort((a, b) => {
        const numA = parseInt(a.name.replace(/\D/g, '')) || 0;
        const numB = parseInt(b.name.replace(/\D/g, '')) || 0;

        return numB - numA;
      });

      return [
        {
          id: 'root-all',
          name: 'Todas',
          children: sortedHCP,
        },
      ];
    },
    
    inputProxy: {
      get() {
        return this.input;
      },
      set(val) {
        this.$emit('update:input', val);
      },
    },
  },

  watch: {
    input() {
    }
  },
};
</script>

<style>
.v-treeview-node__label {
  text-align: start !important;
}

.v-treeview-node__root {
  margin: 0px 0px 0px 0px !important;
}
</style>
